export function filterObject<T extends Record<string, any>>(obj: T, fn: (params: {key: keyof T; value: T[keyof T]}) => boolean): T {
    return Object.fromEntries(Object.entries(obj).filter(([key, value]: [any, any]) => fn({key, value}))) as any;
}
